<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <!-- Binfo -->
        <li class="divider"></li>
        <li class="nav-title">Binfo</li>
        <li class="nav-item">
          <router-link :to="{name: 'Files'}" class="nav-link" exact><i class="icon-docs"></i>Files</router-link>
        </li>

        <!-- Store -->
        <li class="divider"></li>
        <li class="nav-title">Store</li>
        <li class="nav-item">
          <router-link :to="{name: 'Products'}" class="nav-link" exact><i class="icon-layers"></i>Products</router-link>
        </li>

        <!-- Offers -->
        <li class="divider"></li>
        <li class="nav-title">Offers</li>
        <li class="nav-item">
          <router-link :to="{name: 'Offers'}" class="nav-link" exact><i class="icon-globe"></i>Product Offers</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'Catalogs'}" class="nav-link" exact><i class="icon-tag"></i>Catalogs</router-link>
        </li>

        <!-- Store Assets -->
        <li class="divider"></li>
        <li class="nav-title">Store Assets</li>
        <li class="nav-item">
          <router-link :to="{name: 'Promotions'}" class="nav-link" exact><i class="icon-picture"></i>Promotions</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'Previews'}" class="nav-link" exact><i class="icon-frame"></i>Previews</router-link>
        </li>

        <!-- Auth -->
        <li class="divider"></li>
        <li class="nav-title">Auth</li>
        <li class="nav-item">
          <router-link :to="{name: 'Apps'}" class="nav-link" exact><i class="icon-game-controller"></i>Apps</router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{name: 'Devices'}" class="nav-link" exact><i class="icon-screen-smartphone"></i>Devices</router-link>
        </li>

        <!-- Admin -->
        <li class="divider"></li>
        <li class="nav-title">Admin</li>
        <li class="nav-item">
          <router-link :to="{name: 'ActivityLogs'}" class="nav-link" exact><i class="icon-clock"></i>Activity Logs</router-link>
        </li>

      </ul>
    </nav>
  </div>
</template>
<script>

export default {
  name: 'sidebar',
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue